import { ComponentItem as e, ItemType as t, RGB as n } from "@magnopus-opensource/magnopus-web-common";
import { createStore as r } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/vanilla.mjs";
import { subscribeWithSelector as i } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/middleware.mjs";
import { AvatarType as a, handleSubscribers as o } from "@magnopus-opensource/connected-spaces-platform-web-api";
//#region src/state.ts
var s = "editing-tool-snap-vertical", c = "true", l = "false", u = /* @__PURE__ */ function(e) {
	return e[e.NotLoaded = 0] = "NotLoaded", e[e.LoadingInProgress = 1] = "LoadingInProgress", e[e.LoadingComplete = 2] = "LoadingComplete", e;
}({}), d = /* @__PURE__ */ function(e) {
	return e[e.NONE = 0] = "NONE", e[e.AR = 1] = "AR", e[e.VR = 2] = "VR", e;
}({}), f = /* @__PURE__ */ function(e) {
	return e[e.None = 0] = "None", e[e.Capture = 1] = "Capture", e[e.Edit = 2] = "Edit", e[e.View = 3] = "View", e;
}({}), p = { xrMode: 0 }, m = { commentsVisible: !0 }, h = {
	cinematicCameraModeActive: !1,
	cinematicCameraOverlaysEnabled: !0,
	activeCinematicCamera: void 0,
	showAvatarInCinematicCamera: !0,
	showAvatarNameInCinematicCamera: !0,
	cinematicCameraScreenshotResolutionStore: /* @__PURE__ */ new Map()
}, g = {
	collidersVisible: !1,
	editorHelpersVisible: !0,
	renderMode: "solid",
	gridResolution: "off",
	visualisationMode: "default"
}, _ = { clippingPlanes: {
	near: .15,
	far: 2e3
} }, v = { snapMoveVerticallyDown: localStorage.getItem(s) === c }, y = {
	showBasemap: !1,
	showBasemap3d: !1,
	basemapAttribution: void 0,
	isSpaceGeoLocated: !1,
	spaceGeoLocation: {
		latitude: 0,
		longitude: 0,
		orientation: 0
	},
	spaceBaseMapSettings: { tiles3dEnabled: !1 }
}, b = { componentTypesFilteredOut: [] }, x = {
	measurementToolActive: !1,
	hasMeasurement: !1,
	clearMeasurementSignal: 0
}, S = 1.2;
function C(e) {
	let { selectedObjects: n, lastSelectedItem: r, focusedComponent: i } = e;
	if (r?.itemType === t.ComponentItem) return r;
	let a = n.find((e) => e.itemType === t.ComponentItem);
	if (a) return a;
	if (i && n.length > 0 && n.every((e) => e.entityId === i.entityId)) return i;
}
function w(e, n) {
	return e.filter((e) => e.itemType !== t.ComponentItem || e.entityId !== n.entityId);
}
function T(e, t) {
	if (e.length === t.length) {
		let n = e.map((e) => e.asStringId).sort(), r = t.map((e) => e.asStringId).sort();
		if (n.reduce((e, t, n) => e && t === r[n], !0)) return !0;
	}
	return !1;
}
var E = r()(i((r, i) => ({
	debugPicking: !1,
	...p,
	playMode: "3D",
	spawnPointId: void 0,
	uiVisible: !0,
	fullScreen: !1,
	setDebugPicking: (e) => r(() => ({ debugPicking: e })),
	selectedObjects: [],
	addToSelection: (e) => r(() => {
		let n = [...i().selectedObjects];
		return n.find((t) => t.equals(e)) === void 0 ? (e.itemType === t.EntityItem && (n = w(n, e)), n.push(e), {
			selectedObjects: [...n],
			lastSelectedItem: e,
			focusedComponent: void 0
		}) : {};
	}),
	removeFromSelection: (e) => r(() => {
		let t = [...i().selectedObjects], n = i().lastSelectedItem, r = t.findIndex((t) => t.equals(e));
		if (r >= 0) {
			t.splice(r, 1);
			let i = { selectedObjects: [...t] };
			return (n === void 0 || n.equals(e)) && (i.lastSelectedItem = t.length > 0 ? t[t.length - 1] : void 0), i;
		}
		return {};
	}),
	removeHierarchyFromSelection: (e) => r(() => {
		let t = i().selectedObjects, n = i().lastSelectedItem, r = t.filter((t) => t.entityId !== e.entityId), a = n;
		return (n === void 0 || n.entityId === e.entityId) && (a = r.length > 0 ? r[r.length - 1] : void 0), {
			selectedObjects: r,
			lastSelectedItem: a
		};
	}),
	toggleSelection: (e) => r(() => {
		let n = [...i().selectedObjects], r = n.findIndex((t) => t.equals(e)), a;
		return r === -1 ? (e.itemType === t.EntityItem && (n = w(n, e)), n.push(e), a = e) : (n.splice(r, 1), a = n.length > 0 ? n[n.length - 1] : void 0), {
			selectedObjects: [...n],
			lastSelectedItem: a,
			focusedComponent: void 0
		};
	}),
	setSelection: (e, t) => {
		let n = i();
		n.lastSelectedItem?.asStringId === e.asStringId && n.selectedObjects.length === 1 && n.selectedObjects[0]?.asStringId === e.asStringId ? n.focusedComponent?.asStringId !== t?.asStringId && r(() => ({ focusedComponent: t })) : r(() => ({
			selectedObjects: [e],
			lastSelectedItem: e,
			focusedComponent: t
		}));
	},
	setMultiSelection: (e) => {
		let t = e.length > 0 ? e[e.length - 1] : void 0, n = i();
		(!T(n.selectedObjects, e) || n.lastSelectedItem?.asStringId !== t?.asStringId) && r(() => ({
			selectedObjects: e,
			lastSelectedItem: t,
			focusedComponent: void 0
		}));
	},
	clearSelections: () => {
		let e = i();
		(e.selectedObjects.length > 0 || e.lastSelectedItem !== void 0) && r(() => ({
			selectedObjects: [],
			lastSelectedItem: void 0,
			focusedComponent: void 0
		}));
	},
	lastSelectedItem: void 0,
	focusedComponent: void 0,
	itemIsSelected: (e) => i().selectedObjects.find((t) => t.equals(e)) !== void 0,
	selectionEnabled: !1,
	interactionMode: "translate",
	setInteractionMode: (e) => r(() => ({ interactionMode: e })),
	userMode: "endUser",
	setUserMode: (e) => {
		r((t) => t.cameraType !== "mapMode" && t.userSpacePermission !== "creator" && e === "creator" ? {} : { userMode: e });
	},
	annotationMode: 0,
	setAnnotationMode: (e) => r(() => ({ annotationMode: e })),
	userSpacePermission: "endUser",
	setUserSpacePermission: (e) => r(() => ({ userSpacePermission: e })),
	activeComponentId: void 0,
	setActiveComponentId: (t, n) => {
		let i = new e(t, n);
		r(() => ({ activeComponentId: i }));
	},
	clearActiveComponentId: () => {
		r(() => ({ activeComponentId: void 0 }));
	},
	cameraType: "default",
	setCameraType: (e) => r(() => ({ cameraType: e })),
	...m,
	setCommentsVisible: (e) => {
		r(() => ({ commentsVisible: e }));
	},
	avatarUrl: "",
	avatarId: "",
	avatarType: a.None,
	avatarPortrait: "",
	avatarVisible: !0,
	setAvatarUrl: (e) => {
		r(() => ({ avatarUrl: e }));
	},
	setAvatarId: (e) => {
		r(() => ({ avatarId: e }));
	},
	setAvatarType: (e) => {
		r(() => ({ avatarType: e }));
	},
	setAvatarPortrait: (e) => {
		r(() => ({ avatarPortrait: e }));
	},
	setAvatarVisible: (e) => {
		r(() => ({ avatarVisible: e }));
	},
	showEmoteOptions: !1,
	setShowEmoteOptions: (e) => r(() => ({ showEmoteOptions: e })),
	...y,
	setShowBasemap: (e) => {
		r(() => ({ showBasemap: e }));
	},
	setShowBasemap3d: (e) => {
		r(() => ({ showBasemap3d: e }));
	},
	setBasemapAttribution: (e) => {
		r(() => ({ basemapAttribution: e }));
	},
	setSpaceBaseMapSettings: (e) => {
		r(() => ({ spaceBaseMapSettings: e }));
	},
	...g,
	setCollidersVisible: (e) => {
		r(() => ({ collidersVisible: e }));
	},
	setEditorHelpersVisible: (e) => {
		r(() => ({ editorHelpersVisible: e }));
	},
	setRenderMode: (e) => {
		r(() => ({ renderMode: e }));
	},
	setGridResolution: (e) => {
		r(() => ({ gridResolution: e }));
	},
	setVisualisationMode: (e) => {
		r(() => ({ visualisationMode: e }));
	},
	..._,
	setClippingPlanes: (e) => {
		r(() => ({ clippingPlanes: e }));
	},
	setPlayMode: (e) => r(() => ({ playMode: e })),
	setSpawnPointId: (e) => r(() => ({ spawnPointId: e })),
	setUIVisible: (e) => r(() => ({ uiVisible: e })),
	setFullScreen: (e) => r(() => ({ fullScreen: e })),
	...v,
	setMoveSnapVerticallyDown: (e) => {
		localStorage.setItem(s, e ? c : l), r(() => ({ snapMoveVerticallyDown: e }));
	},
	setSpaceGeolocation: (e, t, n) => {
		r(() => ({
			isSpaceGeoLocated: !0,
			spaceGeoLocation: {
				latitude: e,
				longitude: t,
				orientation: n
			}
		}));
	},
	clearSpaceGeolocation: () => {
		r(() => ({
			isSpaceGeoLocated: !1,
			spaceGeoLocation: {
				latitude: 0,
				longitude: 0,
				orientation: 0
			}
		}));
	},
	...b,
	setComponentTypesFilteredOut: (e) => r(() => ({ componentTypesFilteredOut: e })),
	reset: () => r(() => ({
		...p,
		cameraType: "default",
		playMode: "3D",
		selectedObjects: [],
		lastSelectedItem: void 0,
		spawnPointId: void 0,
		selectionEnabled: !1,
		navigationSpeed: S,
		...m,
		...y,
		...b,
		...v,
		...g,
		..._,
		...x
	})),
	version: {
		version: "",
		revision: ""
	},
	setVersion: (e) => r(() => ({ version: e })),
	nativeHdrSupported: !1,
	activeRenderer: void 0,
	linkedInputFields: { scale: !0 },
	gizmoCoordinateMode: "world",
	setGizmoCoordinateMode: (e) => r(() => ({ gizmoCoordinateMode: e })),
	...x,
	setMeasurementToolActive: (e) => r(() => ({ measurementToolActive: e })),
	setHasMeasurement: (e) => r(() => ({ hasMeasurement: e })),
	requestClearMeasurement: () => r((e) => ({ clearMeasurementSignal: e.clearMeasurementSignal + 1 })),
	...h,
	setActiveCinematicCamera: (e) => {
		r(() => ({
			cinematicCameraModeActive: !!e,
			activeCinematicCamera: e
		}));
	},
	setShowAvatarInCinematicCamera: (e) => {
		r(() => ({ showAvatarInCinematicCamera: e }));
	},
	setCinematicCameraOverlaysEnabled: (e) => {
		r(() => ({ cinematicCameraOverlaysEnabled: e }));
	},
	setShowAvatarNameInCinematicCamera: (e) => {
		r(() => ({ showAvatarNameInCinematicCamera: e }));
	},
	setCinematicCameraScreenshotResolutionStore: (e) => {
		r(() => ({ cinematicCameraScreenshotResolutionStore: e }));
	},
	showPerformanceStats: !1,
	navigationSpeed: S,
	setNavigationSpeed: (e) => r(() => ({ navigationSpeed: e })),
	resetNavigationSpeed: () => r(() => ({ navigationSpeed: S })),
	eCommerceIconColours: {
		background: new n(1, 1, 1),
		foreground: new n(0, 0, 0)
	},
	setECommerceIconColours: (e) => r(() => ({ eCommerceIconColours: e }))
})));
o(E);
//#endregion
export { f as AnnotationMode, u as SceneLoadingStatus, d as XRMode, C as activeComponentForSelection, E as gameStateStore };
